import api from "../services/api.service";

/**
 * Le fichier est téléchargé avec le jeton dans l'en-tête, comme tout appel, puis
 * servi au navigateur par une adresse locale. Il voyageait dans l'adresse
 * (`?token=`), d'où il finissait dans les journaux et contournait le contrôle
 * d'offre (ticket #29). L'appelant libère l'adresse (`URL.revokeObjectURL`).
 */
export const fetchFileObjectUrl = async (colocId: string, fileName: string): Promise<string> => {
  const response = await api.get(`files/${colocId}/${encodeURIComponent(fileName)}`, {
    responseType: "blob",
  });
  return URL.createObjectURL(response.data);
};

export const openFileInNewTab = async (colocId: string, fileName: string): Promise<void> => {
  // Ouverte AVANT l'attente : ouverte après, le navigateur la bloque.
  const fenetre = window.open("", "_blank");
  try {
    const url = await fetchFileObjectUrl(colocId, fileName);
    if (fenetre) fenetre.location.href = url;
    // L'onglet a eu le temps de charger le fichier : on libère la mémoire.
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch {
    fenetre?.close();
  }
};
